<template>
    <form class="flex overflow-hidden flex-col py-40 rounded lg:w-10/12 lg:mx-auto lg:py-64" @keypress.enter.prevent>
        <div v-if="success || errorMessage.length"
             class="flex items-center px-5 py-16 text-white lg:px-0 lg:grid lg:grid-cols-10 lg:gap-x-4 lg:h-113 bg-purple">
            <h2 class="lg:col-span-8 lg:col-start-2">
                <span v-if="errorMessage">{{ errorMessage }}</span>
                <slot v-else name="thankyou" />
            </h2>
        </div>
        <template v-else>
            <div class="px-5 pt-10 pb-5 text-white bg-purple lg:px-0 lg:grid lg:grid-cols-10 lg:gap-x-4">
                <h4 class="py-4 lg:col-start-2 lg:col-span-8">
                    <slot name="headline" />
                </h4>
            </div>
            <div class="pt-8 bg-white text-purple lg:grid lg:grid-cols-10 lg:gap-x-4">
                <h4 class="px-5 mb-10 lg:mb-0 lg:px-0 lg:col-span-8 lg:col-start-2">
                    <slot name="subheadline" />
                </h4>
                <div class="px-5 lg:px-0 lg:col-span-8 lg:col-start-2">
                    <div class="grid gap-y-4 mt-6 mb-9 lg:grid-cols-2 lg:gap-x-4 lg:gap-y-6">
                        <slot />
                    </div>
                    <div class="my-6 lg:w-3/4">
                        <slot name="privacy" :toggle="toggle" />
                    </div>
                </div>
                <div class="px-5 my-8 lg:px-0 lg:col-span-8 lg:col-start-2">
                    <div class="flex justify-end mb-4">
                        <button class="button"
                                type="submit"
                                id="submit-form"
                                :disabled="!checked || loading"
                                @click.prevent="submit">
                            {{ submitLabel }}
                        </button>
                    </div>
                    <div class="form-prose">
                        <slot name="privacynotice" />
                    </div>
                </div>
            </div>
        </template>
    </form>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios from 'axios';

const FORM_ENDPOINT = '/.rest/api/v2/form/service';

@Component
export default class ServiceForm extends Vue {
    @Prop({ required: true }) backLabel: string;
    @Prop({ required: true }) submitLabel: string;
    @Prop({ required: true }) serverError: string;

    success = false;
    checked = false;
    loading = false;
    errorMessage = '';

    async submit({ target }) {
        this.errorMessage = '';
        this.loading = true;
        const form: HTMLFormElement = target.form;
        const fd: FormData = new FormData(form);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedFd: URLSearchParams = new URLSearchParams(fd as any); // this works but type checking fails without `any`

        try {
            if (form.checkValidity()) {
                const res = await axios({
                    method: 'post',
                    url: `${this.$contextPath}${FORM_ENDPOINT}/${this.$site}/${this.$lang}`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data: encodedFd
                });
                if (res.data.success) {
                    this.success = true;
                } else {
                    this.errorMessage = this.serverError;
                }
                this.loading = false;
            } else {
                for (let i = 0; i < form.elements.length; i++) {
                    // trigger html validation messages
                    if (!(form.elements[i] as HTMLFormElement).reportValidity()) {
                        this.loading = false;
                        break;
                    }
                }
            }
        } catch (err) {
            this.errorMessage = this.serverError;
            this.loading = false;
        }

        // scroll to top of section
        let section: HTMLElement = form.offsetParent as HTMLElement;
        while (section.tagName.toLowerCase() !== 'section') {
            section = section.offsetParent as HTMLElement;
        }
        window.scrollTo({ top: section.offsetTop, behavior: 'smooth' });
    }

    toggle() {
        this.checked = !this.checked;
    }
}
</script>
